(function () {
    'use strict';
   
    angular.module('ib-apis-form-module', [
        'ib-passenger-tabs-module',
        'ib-passenger-info-form-module',
        'ib-contact-data-tab-module',
        'ib-destination-info-module',
        'ib-origin-info-module',
        'ib-passenger-basic-info-module',
        'ib-passenger-docs-module',
        'ib-passenger-visa-module'
    ]);
})();